export default "__VITE_ASSET__5fe4e0e4__"